import axios from 'axios';
import config from '../config';

export async function createDeliveryAddress(data: any) {
  if (!data) return;
  try {
    const res = await axios.post(`${config.baseUrl}/api/v2/med-link/prescription/createDeliveryAddress`, data);
    return Promise.resolve(res.data);
  } catch (err) {
    console.log(err);
  }
}
export async function updateDeliveryAddress(data: any) {
  if (!data) return;
  try {
    const res = await axios.put(`${config.baseUrl}/api/pharmacy_center/profile/updateDeliveryAddress`, data);
    return Promise.resolve(res.data);
  } catch (err) {
    console.log(err);
  }
}

export async function getProfileAddress(profile_id: any) {
  if (!profile_id) return;
  try {
    const res = await axios.get(`${config.baseUrl}/api/v2/med-link/prescription/getProfileAddress`, {
      params: {
        profile_id: profile_id,
      },
    });
    return Promise.resolve(res.data);
  } catch (err) {
    console.log(err);
  }
}
